import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	DeviceEdgeModuleDto,
	Equipment,
	IDeviceEdgeModuleDto,
	ISiteEquipment,
	PropertyState,
	PropertyType,
} from 'shared/api/api';
import { WebAppState } from 'web/state/store.web';
import { GetDeviceProxyProperties } from 'shared/state/ducks/iot-hub/operations';
import { equipmentPrefix } from './equipment-information-helpers';

export const useGetDeviceProxyProperties = (equipment?: ISiteEquipment): IDeviceEdgeModuleDto | undefined => {
	const dispatch = useDispatch();
	const edgeModule = useSelector((state: WebAppState) => state.iotHub.edgeModule);

	const ipAddressKey = useMemo(
		() => (equipment ? `${equipmentPrefix(equipment.equipment)}EndpointAddress` : '-'),
		[equipment],
	);

	useEffect(() => {
		if (!equipment || !equipment.code) return;

		const code = equipment.code;
		const equipmentType = equipment.equipment;

		const request = DeviceEdgeModuleDto.fromJS({
			code: code,
			equipment: equipmentType,
			properties: [
				{ propertyName: 'timeZone', state: PropertyState.Desired, type: PropertyType.Text },
				{ propertyName: 'timeZone', state: PropertyState.Reported, type: PropertyType.Text },
				{ propertyName: ipAddressKey, state: PropertyState.Desired, type: PropertyType.IpAddress },
				{ propertyName: ipAddressKey, state: PropertyState.Reported, type: PropertyType.IpAddress },
			],
		});

		GetDeviceProxyProperties(request)(dispatch);
	}, [dispatch, equipment, equipment?.code, equipment?.equipment, ipAddressKey]);

	return edgeModule;
};
